'use client';

import type { FormStep } from '@commenda/types';
import type React from 'react';
import { ModuleRenderer } from './ModuleRenderer';

export const StepRenderer = ({
  step,
  componentRegistry,
}: {
  step: FormStep;
  componentRegistry: Record<string, React.FC<any>>;
}) => {
  if (!step?.modules?.length) {
    return (
      <div className="text-center py-8">
        <p className="txt-small-regular text-text-tertiary">
          This step has no modules configured.
        </p>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col gap-8">
      {step.modules.map((module) => (
        <ModuleRenderer
          key={module.id}
          module={module}
          componentRegistry={componentRegistry}
        />
      ))}
    </div>
  );
};
